// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__AheSK","rootSuccess":"CompleteLink_rootSuccess__2-L3t","rootFailure":"CompleteLink_rootFailure__3lQjx","isDisabled":"CompleteLink_isDisabled__1afSq"};